import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  open,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (!open) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKey);
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-168">
      {open && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-navy/70 backdrop-blur-sm" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" data-id="element-169">
          <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} onClick={e => e.stopPropagation()} className="relative bg-white w-full max-w-2xl max-h-[85vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden" data-id="element-170">
            {/* Header */}
            <div className="flex items-center justify-between px-8 py-5 border-b border-gray-100" data-id="element-171">
              <h2 id="legal-modal-title" className="font-playfair font-bold text-2xl text-navy" data-id="element-172">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Close" className="p-2 rounded-full text-navy/50 hover:text-navy hover:bg-gray-100 transition-colors" data-id="element-173">
                <XIcon size={20} data-id="element-174" />
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto px-8 py-6 text-navy/80 text-sm leading-relaxed space-y-5" data-id="element-175">
              {children}
            </div>

            {/* Footer */}
            <div className="px-8 py-4 border-t border-gray-100 bg-offwhite flex justify-end" data-id="element-176">
              <button onClick={onClose} className="bg-mint hover:bg-mint-dark text-navy font-semibold py-2 px-6 rounded-full transition-colors text-sm" data-id="element-177">
                Got it
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}